import { useEffect } from 'react';
import { useHydrated } from './useHydrated';

export function useResizeObserver(
	observedElement: HTMLElement | null | undefined,
	callback: (entry: ResizeObserverEntry) => void
) {
	const hydrated = useHydrated();

	useEffect(() => {
		if (!hydrated || !observedElement) return;

		const observer = new ResizeObserver((entries) => {
			for (const entry of entries) {
				callback(entry);
			}
		});
		observer.observe(observedElement);
		return () => {
			observer.disconnect();
		};
	}, [hydrated, observedElement]);
}
